import ConfigData from 'config/ConfigData';

type PlanFeature = 'enableHandpickedContent';

interface SearchFilter {
  field: string;
  value: string;
  operator: string;
}

interface KeyUpdatesFilterOption {
  name: string;
  filter?: SearchFilter[];
  filterValue?: string;
}

interface KeyUpdatesFilter {
  name: string;
  type?: 'singleSelect' | 'membership';
  subtype?: string;
  prefix?: string;
  searchState?: string;
  requiredPlanFeature?: PlanFeature;
  lockMessage?: string;
  pages: string[];
  filterName: string;
  optionSelected?: string;
  emptyOptionName?: string;
  configHidden?: boolean;
  customOrder?: number;
  notUseTagsConfig?: boolean;
  options: KeyUpdatesFilterOption[];
}

const configFilters = ConfigData?.filters as Record<string, { configHidden?: boolean } | undefined> | undefined;

const KeyUpdatesFilters: KeyUpdatesFilter[] = [
  {
    name: 'Embargo status',
    type: 'singleSelect',
    searchState: 'embargoStatusCondition',
    requiredPlanFeature: 'enableHandpickedContent',
    lockMessage: 'Upgrade to our Enterprise plan to access<br /> news under embargo when available',
    pages: ['KeyUpdates'],
    filterName: 'embargoStatus',
    optionSelected: 'All updates',
    emptyOptionName: 'All updates',
    configHidden: configFilters?.embargoStatus?.configHidden,
    customOrder: 0,
    options: [
      { name: 'All updates' },
      {
        name: 'Currently embargoed',
        filter: [{ field: 'embargoed', value: 'true', operator: 'str_eq' }],
      },
    ],
  },
  {
    type: 'membership',
    subtype: 'usStateOptions',
    prefix: 'state',
    name: 'State',
    pages: ['KeyUpdates'],
    filterName: 'region',
    optionSelected: '',
    options: [],
    configHidden: configFilters?.state?.configHidden,
  },
  {
    name: 'Publisher type',
    searchState: 'always',
    pages: ['KeyUpdates'],
    filterName: 'tags',
    // Only bypasses default tags config for URL hash encoding/normalization; tag UI/behavior still uses filterName: 'tags'.
    notUseTagsConfig: true,
    configHidden: configFilters?.newsPublisherType?.configHidden,
    options: [
      {
        name: 'U.S. executive branch agency',
      },
      {
        name: 'U.S. judicial branch agency',
      },
      {
        name: 'Congressional office',
      },
      {
        name: 'Congressional legislator personal office',
      },
      {
        name: 'Military',
      },
      {
        name: 'State agency',
      },
      {
        name: 'State legislator personal office',
      },
      {
        name: 'Local/regional agency',
      },
    ],
  },
  {
    name: 'Presidential action',
    searchState: 'always',
    pages: ['KeyUpdates'],
    // hashTags rather than tags so this ANDs with 'Publisher type' instead of being merged into the same tags OR
    filterName: 'hashTags',
    configHidden: configFilters?.newsPresidentialAction?.configHidden,
    options: [
      {
        name: 'Executive Order',
        filterValue: '#ExecutiveOrder',
      },
      {
        name: 'Presidential Proclamation',
        filterValue: '#PresidentialProclamation',
      },
      {
        name: 'Presidential Nomination & Appointment',
        filterValue: '#PresidentialNomination&Appointment',
      },
      {
        name: 'Presidential Memoranda',
        filterValue: '#PresidentialMemoranda',
      },
      {
        name: 'Other presidential actions',
        // The backend gives each presidential action exactly one tag, so this only matches those no sub-rule applied to
        filterValue: '#PresidentialAction',
      },
    ],
  },
];

export default KeyUpdatesFilters;
